import * as React from 'react';

const CheckboxChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 2a2 2 0 012-2h20a2 2 0 012 2v20a2 2 0 01-2 2H2a2 2 0 01-2-2V2z"
        />
        <path
            d="M18.586 6L10 14.525l-3.586-3.56L5 12.368l5 4.965 10-9.929L18.586 6z"
            fill="#fff"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 1h20v-2H2v2zm21 1v20h2V2h-2zm-1 21H2v2h20v-2zM1 22V2h-2v20h2zm1 1a1 1 0 01-1-1h-2a3 3 0 003 3v-2zm21-1a1 1 0 01-1 1v2a3 3 0 003-3h-2zM22 1a1 1 0 011 1h2a3 3 0 00-3-3v2zM2-1a3 3 0 00-3 3h2a1 1 0 011-1v-2z"
        />
    </svg>
);

CheckboxChunkySvg.displayName = 'CheckboxChunkySvg';
export default CheckboxChunkySvg;
